import { Component, inject, Input, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClaimService, FileUtilityService, GlobalConstants, GuidService, LoggingService, SelectedFiles, ToastService } from '@app-core';
import { UploadFileComponent } from '@app-shared';
import { Claim } from 'app/core/models';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
    selector: 'app-upload-document',
    templateUrl: './upload-document.component.html',
    styleUrls: ['./upload-document.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [UploadFileComponent],
})
export class UploadDocumentComponent implements OnInit, OnDestroy {
    @ViewChild(UploadFileComponent) uploadFileComponent: UploadFileComponent;
    @Input() showCard: boolean = true;
    private readonly claimService = inject(ClaimService);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly fileUtility = inject(FileUtilityService);
    private readonly toastService = inject(ToastService);
    private readonly guidService = inject(GuidService);

    claim: Claim;
    allowedTypes: string[] = GlobalConstants.ALLOWED_FILE_TYPES;
    maxFileUpload: number = 2;
    filesLoading = new BehaviorSubject(false);
    selectedFiles: SelectedFiles[] = [];
    private claimSubscription: Subscription;
    isUploading: boolean = false;

    ngOnInit(): void {
        this.claimSubscription = this.claimService.getCurrentClaim().subscribe((claim) => {
            if (claim) {
                this.claim = claim;
            }
            LoggingService.log('upload-document-component:init ', this.claim);
        });
    }

    onFilesChanged(files: any) {
        this.filesLoading.next(true);
        this.selectedFiles.splice(0);
        this.fileUtility.toBase64(files, this.selectedFiles).subscribe((res) => {
            if (res) {
                this.filesLoading.next(false);
                this.selectedFiles = res;
            }
        });
        LoggingService.log('selectedFiles: ' + JSON.stringify(this.selectedFiles));
    }

    uploadPhysicianForm() {
        const formData = new FormData();
        this.selectedFiles.forEach((file) => {
            formData.append('files', file.file);
        });
        this.isUploading = true;
        this.claimService.uploadPhysicianDocument(this.guidService.getGuid(), formData).subscribe({
            next: (response) => {
                LoggingService.log('Application Updated', response);

                this.resetForm();
                this.uploadFileComponent.clearFiles();
                this.isUploading = false;
                this.router.navigate(['/upload-complete']);
            },
            error: (error) => {
                this.isUploading = false;
                LoggingService.error('uploadPhysicianDocument() error:', error);
            },
        });
    }

    onPreviousPage() {
        this.router.navigate(['/success-medical'], { skipLocationChange: true });
    }

    ngOnDestroy(): void {
        if (this.claimSubscription) {
            this.claimSubscription.unsubscribe();
        }
        LoggingService.log('upload-document-component: destroyed');
    }

    private resetForm() {
        this.selectedFiles = [];
    }
}
